module.exports = __webpack_public_path__ + "static/img/speed.c1ebdee1.png";